import ModalInfo from 'components/shared/ModalInfo'
import { FormattedMessage, useIntl } from 'react-intl'
import Text from 'components/shared/Text'
import { useApp } from 'store/steps'
import {
    Step,
    SelfcareStep,
    UnlimitedCardStep,
    UnlimitedRenewStep,
    VouchersStep,
} from 'store/general-slice/types'
import { STEPS, CREATOR_ACCOMMODATION_STEPS } from 'routes/steps'
import { useNavigate } from 'react-router-dom'
import {
    setIsMobileSummaryOpened,
    setNextStepToEdit,
} from 'store/general-slice'
import { useAppDispatch } from 'store/hooks'
import { firstStep } from 'routes/basenames'

interface ModalHeadingProps {
    nextStep:
        | Step
        | SelfcareStep
        | UnlimitedCardStep
        | UnlimitedRenewStep
        | VouchersStep
    isOpened: boolean
}

export const ClearNextStepsModal = ({
    nextStep,
    isOpened,
}: ModalHeadingProps) => {
    const { formatMessage } = useIntl()
    const { language, isCreatorAccommodation } = useApp()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const steps = isCreatorAccommodation ? CREATOR_ACCOMMODATION_STEPS : STEPS

    const { title } = steps.find((step) => step.id === nextStep) || {}
    const nextStepTitle = title ? formatMessage(title) : ''

    const getPath = (stepName: string) =>
        steps.find((step) => step.id === stepName)?.slug[language] || firstStep

    const handleReset = () => {
        dispatch(setNextStepToEdit(null))
    }

    const handleAccept = () => {
        navigate(getPath(nextStep))
        dispatch(setIsMobileSummaryOpened(false))
        dispatch(setNextStepToEdit(null))
    }

    return (
        <ModalInfo
            isOpened={isOpened}
            linkLabel={formatMessage({
                id: 'global.btn.cancel',
                defaultMessage: 'Anuluj',
            })}
            buttonLabel={formatMessage({
                id: 'global.btn.continue',
                defaultMessage: 'Kontynuuj',
            })}
            onButtonClick={handleAccept}
            onLinkClick={handleReset}
            width={490}
        >
            <Text variant="heading3">
                <FormattedMessage
                    id="global.modal.edit_step_title"
                    defaultMessage="Czy na pewno chcesz edytować {step}?"
                    values={{
                        step: nextStepTitle,
                    }}
                />
            </Text>
            <Text variant="body" color="grayscale_900" mt={16}>
                <FormattedMessage
                    id="global.modal.edit_step_description"
                    defaultMessage="Dane i wybory uzupełnione w kolejnych krokach zostaną wyczyszczone – proces zamówienia rozpoczniesz od kroku {step}. Kliknij „Kontynuuj”, aby przenieść się do kroku, który chcesz edytować."
                    values={{
                        step: nextStepTitle,
                    }}
                />
            </Text>
        </ModalInfo>
    )
}
